import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Layout from "../../../common_comp/Layout/Layout";

const editorialBoardData = [
  {
    name: "Editor-in-Chief",
    designation: "Dr. TEJESWARARAO VOONNA (M.V.R. P.G. College, Andhra Pradesh, India)",
    summary: "The journal is currently in the process of appointing an Editor-in-Chief. During this transition, editorial coordination is managed by the Editorial Office and the Managing Editor to ensure smooth manuscript processing.",
  },

  {
    name: "Pharmaceutical Analysis – Small Molecules",
    designation:
      "Victoria Samanidou PhD (Aristotle University of Thessaloniki, Thessaloniki, Greece)",
    link: "https://orcid.org/0000-0002-8493-1106",
    summary: (
      <>
        <p>
          Dr. Victoria Samanidou is Full Professor and Director of the
          Laboratory of Analytical Chemistry in the Department of Chemistry of
          Aristotle University of Thessaloniki, Greece and since 2016 the
          elected President of the Steering Committee of the Association of
          Greek Chemists-Regional Division of Central & Western Macedonia.
        </p>
        <p>
          Her research interests focus on the development of sample preparation
          methods using sorptive extraction prior to chromatographic analysis.
          She has co-authored 198 original research articles in peer-reviewed
          journals and 58 reviews, 64 editorials, and 51 chapters in scientific
          books (h-index 40, Source Scopus, February 2022). She is editorial
          board member of more than 30 scientific journals and guest editor in
          more than 27 special issues. She has peer-reviewed more than 683
          manuscripts for 148 scientific journals.
        </p>
        <p>
          In 2021 she was included in the “The Analytical Scientist” 2021 Power
          List of top 100 influential people in analytical science.
        </p>
      </>
    ),
  },

  {
    name: "Pharmaceutical Analysis – Large Molecules",
    designation:
      "Linzhi Chen, PhD (Boehringer Ingelheim Pharmaceuticals, CT, USA)",
    summary: (
      <>
        <p>
          Dr. Chen Dr. is a Sr. Research Fellow at Boehringer Ingelheim
          Pharmaceuticals. He received his Ph.D. in organic chemistry from the
          University of Mons, Belgium where he studied gas-phase ion chemistry
          by mass spectrometry.
        </p>
        <p>
          {" "}
          After completing his postdoctoral research on ion-molecule reactions,
          he began his industry career with 3M Co. where he spend 5 years on
          metabolite identification/profiling, bioanalysis, and
          pharmacokinetics.
        </p>
        <p>
          {" "}
          He joined Boehringer Ingelheim Pharmaceuticals in 2001 to lead a
          bioanalytical group in support of small molecule drug development. In
          recent years he has been providing LC/MS-based bioanalytical support
          to biotherapeutic development programs and developed a number of LC/MS
          assays for various biotherapeutic proteins such as nanobodies, Fabs,
          bispecific, and mAbs, as well as oligonucleotides.
        </p>
        <p>
          His group also developed immunocapture-LC/MS methodology for
          simultaneous ADA isotyping and semi-quantitation. His recent interest
          focuses on LC/MS determination of in vivo biomodifications of
          biotherapeutics and their impact on PK/PD.
        </p>
      </>
    ),
  },

  {
    name: "Clinical and non-clinical Bioanalysis",
    designation:
      "Yu-Luan Chen, BSc MSc Ph.D (Sunovion Pharmaceuticals, Marlborough, MA, USA).",
    summary: (
      <>
        <p>
          Dr. Yu-Luan Chen is currently Senior Director, Bioanalytical Sciences,
          Clinical Pharmacology, Translational Medicines & Early Development. He
          received his B.Sc degree (Xiamen), M.Sc. degree (Nanjing), and Ph.D.
          degree from the University of British Columbia (Canada).
        </p>
        <p>
          His expertise includes Bioanalytical Sciences and Analytical Chemistry
          with a special focus in Separation Sciences and LC-MS/MS technologies
          applying to clinical pharmacokinetics /pharmacodynamics (PK/PD), drug
          metabolism research, and biomarker assays.
        </p>
        <p>
          Dr. Chen is the editor, Feature Articles for Chinese-American Chemical
          Society (CACS) Communications, an editorial board member for Journal
          of Molecular and Applied Bioanalysis, Drug Metabolism Letters, and The
          Open Spectroscopy Journal. Dr. Chen has published over 50
          peer-reviewed papers and three book chapters.
        </p>
        <p>
          His current research interests include bioanalytical LC-MS/MS method
          development, bioanalytical method validation, PK/PD sample analysis,
          in vitro and in vivo drug metabolism (cold and hot approaches),
          biomarker assays, microsampling technologies, and supporting drug
          discovery and development from nonclinical exploratory through GLP
          toxicology, and from clinical Phase I through new drug application
          further to post-approval commitments.
        </p>
      </>
    ),
  },

  {
    name: "Proteomics in Bioanalysis",
    designation:
      "Irene Panderi BSc PhD, (University of Athens, Athens, Greece).",
    link: "https://orcid.org/0000-0003-3190-0127",
    summary:
      "Irene Panderi is a Professor of Pharmaceutical Analysis at the Laboratory of Pharmaceutical Analysis, Faculty of Pharmacy, National and Kapodistrian University of Athens. Irene Panderi is a pharmacist with over 20 years experience in leading research in the fields of Pharmaceutical Analysis and Analytical Chemistry developing analytical methods for the analysis of drugs, metabolites, and bioactive compounds in pharmaceuticals, cosmeceuticals, biological fluids, and human tissues. These methods are applied to clinical testing, toxicology studies, doping control, and quality control of drugs. She is also a member of the Scientific Committee on Consumers Safety (SCCS).",
  },

  {
    name: "Metabolomics in Bioanalysis",
    designation:
      "Rob J. Vreeken PhD, (Discovery Sciences, Janssen Pharmaceutica, Beerse, Belgium)",
    link: "https://orcid.org/0000-0003-3568-1371",
    summary: (
      <>
        <p>
          Received his Ph.D. from the Free University of Amsterdam (NL).
          Hereafter, he developed and applied a variety of MS-based techniques
          for quantitative and qualitative analysis in academic and commercial
          settings (PD at EPFL (Lausanne, CH) and group leader at KWR
          (Netherlands Drinking Water Research facility) and TNO (CRO and
          research institute)).{" "}
        </p>
        <p>
          {" "}
          Subsequently, he headed the Waters EU applications, training,
          demonstration, and support organizations. After leading the
          pharma-unit at Avantium (CRO, Amsterdam, NL) he joined the Netherlands
          Metabolomics Centre (Leiden Academic Centre for Drug Research, Leiden
          University, NL) as Assistant Professor to create and direct the
          Central Lab facility. Next to teaching, he developed novel strategies
          for e.g. (endogenous) metabolite identification and advanced
          lipidomics, which were used for biomarker discovery in inflammatory
          processes. From July 2014 he directs a team at Janssen Pharmaceutica
          (Johnson & Johnson, Beerse, Belgium) focusing on early-stage pathway
          engagement studies, bioanalysis, and biomarker validation.
        </p>
      </>
    ),
  },

  {
    name: "Lipidomics in Bioanalysis",
    designation:
      "Sophie Ayciriex MSc PhD, (ANABIO-MS Laboratory, Institute of Analytical Sciences, Villeurbanne, France)",

    summary: (
      <>
        <p>
          Earned her M.Sc. degree in Biochemistry and Structural Biology at the
          University Paul Sabatier (Toulouse, France). She obtained her European
          Ph.D. degree in Biochemistry in 2010 at the University of Bordeaux
          Segalen, France. During her Ph.D. fellowship, she investigated the
          characterization of a novel lysolipid acyltransferase in S. cerevisiae
          by combining several biochemistry tools and lipidomics. For her first
          post-doctoral fellowship, she joined the University Paris Descartes –
          Faculty of Pharmacy (CNRS UMR 8638) in Paris, France
        </p>

        <p>
          She developed analytic methods for the analysis of sterols and
          oxysterols by UPLC-ESI-HRMS and conducted lipidomics research in
          relation to neurodegeneration. She is currently pursuing her postdoc
          in analytical chemistry, performing shotgun Lipidomics on
          high-resolution mass spectrometry at Max Planck Institute of Molecular
          Cell Biology and Genetics in Dresden, Germany. System biology of lipid
          metabolism is one of her main research.
        </p>
      </>
    ),
  },

  {
    name: "Pharmacometrics Bioanalysis",
    designation:
      "Michel L. Campos, MSc Ph.D (Federal University of Mato Grosso – UFMT, Sinop, Brazil).",

    summary: (
      <>
        <p>
          Dr. Campos received his MSc and PhD in Pharmaceutical Sciences from
          Sao Paulo State University “Julio de Mesquita Filho” – Faculty of
          Pharmaceutical Sciences, Brazil (2015), with part of the research in
          the Centre for Research in Mass Spectrometry at York University,
          Canada.
        </p>
        <p>
          He worked as a postdoctoral fellow and substitute professor at the
          Federal University of Paraná, Brazil. He joined the Health Sciences
          Institute at the Federal University of Mato Grosso as an Adjunct
          Professor in 2018.
        </p>
        <p>
          His major research interests are Clinical Pharmacokinetics,
          Pharmacokinetics and Pharmacodynamics, Preclinical Testing of New
          Drugs and Medicines, Metabolites Investigation by High-Resolution Mass
          Spectrometry, and Development and Validation of Bioanalytical Methods
          by HPLC and LCMS. Academic experience in Clinical Pharmacology,
          Clinical Pharmacokinetics applied to Dose Determination, Therapeutic
          Drug Monitoring, and Dose Adjustment of Antibiotics from
          Pharmacokinetic and Pharmacodynamic parameters.
        </p>
      </>
    ),
  },
  {
    name: "Forensic Bioanalysis",
    designation:
      "Constantinos Pistos PhD (West Chester University, West Chester, PA, USA).",
    link: "https://orcid.org/0000-0003-3190-0127",
    summary: (
      <>
        <p>
          Dr. Pistos graduated from the department of pharmacy of the Aristotle
          University of Thessaloniki (Greece) in 1995, before he pursued his
          M.Sc. and Ph.D studies, at the Department of Pharmacy of the
          University of Athens (Greece).{" "}
        </p>
        <p>
          In 2001-2002 he continued his research as a postdoctoral fellow at the
          college of pharmacy of the University of Georgia Athens, GA (U.S.A.),
          before serving as director of a private CRO pharmaceutical company in
          Greece.
        </p>
        <p>
          Between 2006 and 2012, he possessed the position of Lecturer and by
          2012 of Assistant Professor in Toxicology at the School of Medicine of
          the University of Athens (Greece)
        </p>
        <p>
          By 2015, Dr. Pistos possesses the position of Assistant Professor of
          Toxicology at the Department of Chemistry at West Chester University
          of Pennsylvania, U.S.A. He has published fifty-two articles and four
          book chapters while he presented thirty-five research works in
          congresses, in the fields of toxicology and pharmaceutical analysis.
        </p>
      </>
    ),
  },
  {
    name: "Regulated and non-regulated Bioanalysis",
    designation:
      "Chukwunonso Nwabufo MSc (Gilead Sciences Alberta ULC, Edmonton AB, Canada).",
    summary: (
      <>
        <p>
          Chukwunonso is an accomplished Pharmaceutical Scientist with over 4
          years of experience in drug development across academia and the
          pharmaceutical industry. He provides an extensive range of analytical
          chemistry services to support drug development programs and was
          recently involved in the development of Remdesivir
        </p>
        <p>
          He has received over 10 awards for research, academic, and leadership
          accomplishments. His current research interest is on the enhancement
          of the clinical efficacy and effectiveness of respiratory and
          neurological medicines. Pharmacokinetics, Pharmacodynamics, and Drug
          Metabolism Community.
        </p>
        <p>
          Prior to joining Gilead Sciences, he completed an MSc in Pharmacy with
          distinction at the University of Saskatchewan with a research focus on
          the preclinical development of novel therapeutic agents for
          Parkinson’s disease.
        </p>
        <p>
          {" "}
          Chukwunonso completed an undergraduate program in Biochemistry at the
          University of Benin with First class honors and thesis research that
          was primarily focused on the effect of Hibiscus Sabdariffa extract on
          the reproductive hormones of male Wistar rats.
        </p>
      </>
    ),
  },
  {
    name: "Bioanalysis in Cell and Gene therapy",
    designation:
      "Tao Niu PhD (Vertex Pharmaceuticals, Boston, MA, 02210, USA).",

    summary: (
      <>
        <p>
          Dr. Niu, is currently an associate director in the clinical &
          quantitative pharmacology department at Vertex Pharmaceuticals. Dr.
          Niu has specialized in population PK, PKPD, exposure-response,
          pediatric label extension using exposure matching, longitudinal
          model-based meta-analysis, Bayesian modeling, and clinical trial
          simulation with a focus on rare diseases.
        </p>
        <p>
          Dr. Niu is the pharmacometrics lead and has 10 years of hands-on
          experience in biologics PK assay, especially in assessing the impact
          of anti-drug antibodies on PK assays. Dr. Niu is also an expert in
          immunogenicity, particularly for protein therapeutics and in vivo gene
          therapy.
        </p>
        <p>
          He is representing Vertex (previously Pfizer) in the IQ Consortium
          Immunogenicity Working Group. Tao received his PhD in pharmaceutics
          from the University of Houston. Dr. Niu also holds an MS in
          pharmacometrics from the University of Maryland and is working towards
          a second MS in data science from the Georgia Institute of Technology.
        </p>
        <p>
          Dr. Niu’s main research interest is to facilitate drug development
          with innovative bioanalytical assays and quantitative models with a
          special focus on in vivo gene therapy.
        </p>
      </>
    ),
  },
  {
    name: "Drug Discovery and Complex Natural Products",
    designation:
      "Abhisheak Sharma, B Pharm M Pharm Ph.D. (Department of Pharmaceutics, College of Pharmacy, University of Florida, Gainesville, FL, USA).",
    summary: (
      <>
        <p>
          {" "}
          Dr. Sharma earned his Ph.D. in pharmacokinetics and metabolism from
          CSIR-Central Drug Research Institute, Lucknow, India. He is a trained
          analytical scientist, pharmacokinetisist, and pharmacist whose
          research focuses on the in vivo and in vitro preclinical
          pharmacokinetic studies of new chemical entities and natural products.{" "}
        </p>
        <p>
          He is proficient in various approaches to bioanalytical method
          development and validation of discovery compounds and plant alkaloids
          in different biological matrices (blood, dried blood spot, plasma,
          serum, tissue homogenates, and urine) using various analytical
          techniques (UPLC-MS/MS, UPLC-PDA-MS, and UPLC-PDA/FL). His research
          interests include translational development of new chemical entities
          to candidate drugs using PK-PD modeling and simulation approach.
        </p>
      </>
    ),
  },
  // {
  //   name: "Automation and Additive Manufacturing in Bioanalysis",
  //   designation:
  //     "Abraham Samuel Finny, Ph.D. (Waters Corporation, Milford, MA, USA).",
  //   link: "https://orcid.org/0000-0003-3190-0127",
  //   summary: (
  //     <>
  //       <p>
  //         Dr. Finny is a Senior Scientist at Waters Corporation, Milford, MA,
  //         USA. He received his M.S. in Biomedical Engineering from the
  //         University of Strathclyde, Glasgow, Scotland, UK, where he studied
  //         controlled drug delivery systems. He earned his Ph.D. in Chemistry at
  //         Clarkson University, Potsdam, NY, USA, where he worked on developing
  //         additive manufacturing platforms and 3D printable formulations for
  //         sensing and environmental applications
  //       </p>
  //       <p>
  //         Apart from his solid academic teaching and research experience,
  //         Abraham has high-quality industrial R&D experience spanning over three
  //         years as an analytical scientist working for leading multinational
  //         biopharmaceutical and biotechnology companies. Some of his research
  //         interests include analytical chemistry, biomaterials, bioprocessing,
  //         additive biomanufacturing, and automation techniques in the field.
  //         Abraham has authored multiple research articles, book chapters, and
  //         review articles.
  //       </p>
  //     </>
  //   ),
  // },

  {
    name: "Environmental Bioanalysis",
    designation:
      "Unnati Kapadnis, B.Pharm, M.Pharm, M.S. (Agios Pharmaceuticals, Cambridge, MA, USA).",
    summary: (
      <>
        <p>
          Mrs. Kapadnis is an experienced bioanalytical scientist currently
          working in DMPK department at Agios Pharmaceuticals. She has over 7
          years of experience in the method development and validation of drug
          candidates and biomarkers using analytical technologies including
          HPLC, LC-MS/MS, and ligand binding assays(ELISA).
        </p>
        <p>
          She has an excellent understanding of Good Laboratory Practices (GLP)
          and Clinical Laboratory Improvement Amendments (CLIA) for method
          validation and sample analysis. She works in cross-functional teams to
          collaborate with drug early-stage discovery, preclinical safety,
          translational sciences, and clinical development scientist to devise
          and implement analytical solutions.
        </p>
        <p>
          {" "}
          Mrs. Kapadnis oversees the generation of quality data to study the
          Pharmacokinetics (PK), Pharmacodynamics (PD), and Toxicokinetics (TK)
          of novel drug candidates. Her current research interests include
          developing novel analytical assays, fine-tuning microsampling
          techniques, optimizing sample collection, extraction, and purification
          processes to achieve optimal separation using chromatography,
          developing and optimizing analytical processes, and evaluating
          emerging analytical technologies for acquisition purposes.
        </p>
      </>
    ),
  },
];

const EditorialBoard = () => {
  return (
    <Layout>
      <Container className="mt-4">
        <h1 className="text-center my-5 fw-bold">Editorial Board</h1>

        {/* Primary Editorial Contacts Section */}
        <div className="mb-5">
          <h2 className="text-center my-4 fw-bold">
            Primary Editorial Contacts
          </h2>
          <Row className="g-4">
            <Col xs={12} md={4}>
              <Card className="shadow border-0 p-3 h-100">
                <Card.Body className="text-center">
                  <h5 className="fw-bold mb-3" style={{ color: "#05263e" }}>
                    Editor-in-Chief
                  </h5>
                  <p className="mb-2 fw-bold">Dr. TEJESWARA RAO VOONNA</p>
                  <p className="text-muted small mb-1">
                    Associate Professor and HOD of Chemistry
                  </p>
                                    <p className="text-muted small mb-3">
                    M.V.R. P.G. College, Andhra Pradesh, India
                  </p>
                  <p className="mb-1 small text-muted">
                    <a href="https://orcid.org/0000-0002-0469-8958">ORCiD</a>
                    
                  </p>
                  <p className="mb-2 small text-muted">
                    <a href="https://www.webofscience.com/wos/author/record/CAA-3638-2022">WOS ID</a>
                  </p>
                  
                  <p className="text-muted small">
                    <strong>For editorial matters, please contact:</strong>
                    <br />
                    <a
                      href="mailto:editorial@journalofappliedbioanalysis.com"
                      className="text-decoration-none"
                    >
                       editorial@journalofappliedbioanalysis.com
                    </a>
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} md={4}>
              <Card className="shadow border-0 p-3 h-100">
                <Card.Body className="text-center">
                  <h5 className="fw-bold mb-3" style={{ color: "#05263e" }}>
                    Managing Editor
                  </h5>
                  <p className="mb-2 fw-bold">Mohd Tehseem</p>
                  <p className="text-muted small mb-3">
                    Green Publication, Haryana, India
                  </p>
                  <p className="text-muted small">
                    <strong>
                      Contact for submissions and journal management:
                    </strong>
                    <br />
                    <a
                      href="mailto:support@journalofappliedbioanalysis.com"
                      className="text-decoration-none"
                    >
                      support@journalofappliedbioanalysis.com
                    </a>
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} md={4}>
              <Card className="shadow border-0 p-3 h-100">
                <Card.Body className="text-center">
                  <h5 className="fw-bold mb-3" style={{ color: "#05263e" }}>
                    Production Editor
                  </h5>
                  <p className="mb-2 fw-bold">Ahmad Akhtar</p>
                  <p className="text-muted small mb-3">
                    Green Publication, Haryana, India
                  </p>
                  <p className="text-muted small">
                    <strong>Contact for production and publication:</strong>
                    <br />
                    <a
                      href="mailto:contact.gpubpress@gmail.com"
                      className="text-decoration-none"
                    >
                      contact.gpubpress@gmail.com
                    </a>
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
        <Row className="g-4">
          {editorialBoardData.map((member, index) => (
            <Col xs={12} key={index}>
              <Card className="shadow border-0 p-2">
                <Card.Body>
                  <p className="mb-3 fw-bold">{member.name}</p>

                  <details>
                    <summary className="fw-bold text-muted mb-2">
                      {member.designation}
                    </summary>
                    <p className="text-muted fw-bold">
                      <Link to={member.link}>{member.link}</Link>
                    </p>

                    <div className="text-muted">{member.summary}</div>
                  </details>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <h2 className=" my-5 fw-bold">
          International Editorial Advisory Board
        </h2>
        <ul className="joab-common-para mb-4">
          <li className="mb-2">
            <span className="fw-bold">
              Jeffery Hackett MSc PhD D-ABFT CSci CChem FRSC
            </span>{" "}
            (Forensic Laboratory Division, Office of Chief Medical Examiner, San
            Francisco, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Leimin Fan BSc PhD</span> (RockTown
            Technology and Service, Libertyville, IL, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Lùcia Carrano PhD</span> (Fondazione
            Instituto Insubrico Ricerca per La Vita, Gerenzano, Italy).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Alexander Buko PhD</span>(Human Metabolome
            Technologies, Boston, MA, USA).
          </li>

          <li className="mb-2">
            <span className="fw-bold">Xiaobin Xu BSc MSc PhD</span>(Regeneron
            Pharmaceuticals, Tarrytown, NY, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Mu Chen PhD</span> (Frontage Labs, Exton,
            PA, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Andreas Tsakalof PhD</span> (University of
            Thessaly, Volos, Greece).
          </li>

          <li className="mb-2">
            <span className="fw-bold">Kai Wang, PhD</span>(Frontage
            Laboratories, Inc., Exton, PA, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Morse Faria, PhD</span>(PPD Laboratories,
            Richmond, VA, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Padmanabhan Eangoor, PhD </span>(Discovery
            Bioanalysis, Merck & Co, Boston, MA, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Lake Paul, PhD </span> (Abzena, Bristol,
            PA,USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Mohammad Sharif Khan PhD </span> (Thayer
            School of Engineering, Dartmouth College, Hanover, NH, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Mark Shapiro MSc </span> (MCS Pharma
            Consulting LLC, Stokesdale, NC, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Yongle Pang PhD</span>(GlaxoSmithKline,
            Collegeville, PA, USA).
          </li>
          <li className="mb-2">
            <span className="fw-bold">Amrinder Singh PhD </span> (St. Jude
            Children Research Hostpital. Memphis, TN, USA).
          </li>
        </ul>
      </Container>
    </Layout>
  );
};

export default EditorialBoard;
